import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkIcon from '@mui/icons-material/Link';
import {Network} from '../../types';
import TwitchIcon from '../icons/twitch';
import TiktokIcon from '../icons/tiktok';
import {SvgIconProps, useTheme} from '@mui/material';
import {Colors} from '../common/colors';
import Link from 'next/link';

type NetworkLinkProps = {
    network: Network;
    url: string;
};

export default function NetworkLink(props: NetworkLinkProps) {
    return (
        <Link target="_blank" href={props.url} aria-label={props.network}>
            <NetworkIcon network={props.network} />
        </Link>
    );
}

type NetworkIconProps = {
    network: Network;
};

export function NetworkIcon(props: NetworkIconProps & SvgIconProps) {
    const theme = useTheme();
    const isDark = theme.palette.mode == 'dark';
    const color = {
        color: isDark ? Colors.grey : 'white',
        backgroundColor: isDark ? Colors.light : Colors.grey,
        borderRadius: '5px',
        marginRight: '15px',
        padding: '5px',
    };
    return (
        <>
            {props.network == Network.YOUTUBE && (
                <YouTubeIcon sx={color} fontSize="large" {...props} />
            )}
            {props.network == Network.FACEBOOK && (
                <FacebookIcon sx={color} fontSize="large" {...props} />
            )}
            {props.network == Network.INSTAGRAM && (
                <InstagramIcon sx={color} fontSize="large" {...props} />
            )}
            {props.network == Network.TWITCH && (
                <TwitchIcon sx={color} fontSize="large" {...props} />
            )}
            {props.network == Network.TWITTER && (
                <TwitterIcon sx={color} fontSize="large" {...props} />
            )}
            {props.network == Network.TIKTOK && (
                <TiktokIcon sx={color} fontSize="large" {...props} />
            )}
            {props.network == Network.WEBSITE && (
                <LinkIcon sx={color} fontSize="large" {...props} />
            )}
        </>
    );
}
